import React from 'react';
import './styles.css';

const targetMarketIcon = (
  <svg
    styleName="icon-cell"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
  >
    <g>
      <path
        d="M12,23.5C5.659,23.5,0.5,18.341,0.5,12C0.5,5.657,5.659,0.5,12,0.5c6.342,0,11.5,5.157,11.5,11.5
        C23.5,18.341,18.342,23.5,12,23.5z M12,1.5C6.21,1.5,1.5,6.209,1.5,12c0,5.789,4.71,10.5,10.5,10.5S22.5,17.789,22.5,12
        C22.5,6.209,17.79,1.5,12,1.5z"
      />
      <g>
        <path
          d="M11.975,4.02c-0.276,0-0.5-0.225-0.5-0.5v-2c0-0.275,0.224-0.5,0.5-0.5s0.5,0.225,0.5,0.5v2
          C12.475,3.795,12.251,4.02,11.975,4.02z"
        />
        <path
          d="M11.975,23.02c-0.276,0-0.5-0.225-0.5-0.5v-2c0-0.275,0.224-0.5,0.5-0.5s0.5,0.225,0.5,0.5v2
          C12.475,22.795,12.251,23.02,11.975,23.02z"
        />
      </g>
      <g>
        <path
          d="M3.475,12.52h-2c-0.276,0-0.5-0.225-0.5-0.5s0.224-0.5,0.5-0.5h2c0.276,0,0.5,0.225,0.5,0.5S3.751,12.52,3.475,12.52z"
        />
        <path
          d="M22.475,12.52h-2c-0.275,0-0.5-0.225-0.5-0.5s0.225-0.5,0.5-0.5h2c0.276,0,0.5,0.225,0.5,0.5S22.751,12.52,22.475,12.52z"
        />
      </g>
      <g>
        <path
          d="M11.975,15.896c-2.571,0-4.375-4.136-4.375-6.375c0-2.412,1.962-4.375,4.375-4.375c2.414,0,4.375,1.963,4.375,4.375
          C16.35,11.76,14.546,15.896,11.975,15.896z M11.975,6.146c-1.861,0-3.375,1.514-3.375,3.375c0,2.021,1.635,5.375,3.375,5.375
          c1.74,0,3.375-3.354,3.375-5.375C15.35,7.659,13.836,6.146,11.975,6.146z"
        />
        <path
          d="M6.975,19.02c-0.276,0-0.5-0.225-0.5-0.5v-1.208c0-1.514,1.337-2.792,2.921-2.792h1.079c0.276,0,0.5,0.225,0.5,0.5
          s-0.224,0.5-0.5,0.5H9.396c-1.023,0-1.921,0.837-1.921,1.792v1.208C7.475,18.795,7.251,19.02,6.975,19.02z"
        />
        <path
          d="M16.975,19.02c-0.275,0-0.5-0.225-0.5-0.5v-1.208c0-0.866-0.373-1.792-1.42-1.792h-1.58c-0.275,0-0.5-0.225-0.5-0.5
          s0.225-0.5,0.5-0.5h1.58c1.447,0,2.42,1.122,2.42,2.792v1.208C17.475,18.795,17.251,19.02,16.975,19.02z"
        />
      </g>
    </g>
  </svg>
);

export default targetMarketIcon;
